import { useEffect, useRef } from "react";
import calendarImage from "@/public/calendar.jpg"
import { useCommunication } from "@/lib/CommunicationWrapper";
import { useCalendarSync } from "@/lib/calendarSync";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { CalendarSyncSettings } from "./CalendarSyncGoogle";
import { useAuthStep } from "@/hooks/useAuthStep";
import { GoogleSvg, MicrosoftSvg } from "@/lib/svg";
import { XIcon } from "lucide-react";



type CalendarSyncGateProps = {
    showCloseButton?: boolean;
};

export const CalendarSyncGate = ({ showCloseButton = false }: CalendarSyncGateProps) => {

    const { useRerenderListener, authenticatedFetch, updateOptions, closeModal } = useCommunication();
    const { setAuthStep } = useAuthStep();
    const { options } = useRerenderListener(["google_cal_sync_token", "microsoft_cal_sync_token"]);
    const { handleGoogleLogin, handleMicrosoftLogin } = useCalendarSync();

    const params = new URLSearchParams(window.location.search);
    const signup = params.get("signup") === "true";
    const canClose = showCloseButton && !signup;

    const handleNext = () => {
        setAuthStep("questionairre");
    }

    const NextButton = () => {

        if (options.google_cal_sync_token || options.microsoft_cal_sync_token) {
            return (
                <div className="relative h-[44px] mt-4">
                    <button onClick={handleNext} className="flex items-center justify-center gap-[8px] h-[44px] rounded-full w-full font-medium text-white bg-brand-gradient">Next</button>
                </div>
            )
        }

        return (
            <div className="relative h-[44px] mt-4">
                <button onClick={handleNext} className="flex items-center justify-center gap-[8px] h-[44px] rounded-full w-full font-medium text-gray-600">Skip</button>
            </div>
        )
    }

    if (options.google_cal_sync_token) {

        return (
            <div className="pt-2">
                <CalendarSyncSettings signup={signup} />
                {signup && <NextButton />}
            </div>
        )
    }


    return (
        <div className="relative flex-1 flex flex-col w-full h-full">
            {canClose && (
                <button
                    type="button"
                    onClick={closeModal}
                    className="ring-offset-background focus-visible:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs transition-opacity hover:opacity-70 focus-visible:ring-2 focus-visible:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"
                    aria-label="Close"
                >
                    <XIcon className="text-base-1" />
                </button>
            )}
            <p className="text-sm text-gray-500 mb-2">We'll sync assignments to your calendar for you</p>
            <div className="flex flex-col w-full gap-2 items-center">
               
                <div className="h-[220px] mb-2">
                    <img src={"/calendar.jpg"} alt="Calendar" className="w-full h-full object-cover" />
                </div>

                <button onClick={handleGoogleLogin} className="flex items-center justify-center gap-3 hover:brightness-95 transition-all duration-300 bg-white border border-[#e5e5e5] rounded-xl py-5 w-full font-medium">
                    <GoogleSvg className="w-5 h-5" />
                    Sync with Google
                </button>
                <button onClick={handleMicrosoftLogin} className="flex items-center justify-center gap-3 hover:brightness-95 transition-all duration-300 bg-white border border-[#e5e5e5] rounded-xl py-5 w-full font-medium">
                    <MicrosoftSvg className="w-5 h-5" />
                    Sync with Microsoft
                </button>
            </div>
            {signup && <NextButton />}
        </div>
    );
};
